import { DateInt12 } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { User } from './user.model';

export class Comment extends ApiData {
    text?: string;
    user?: User;
    creationDate?: DateInt12;

    fieldDictionary() {
        return {
            user: User
        };
    }
}
